<template>
  <div class="nd-number-counter">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-4">
        <nd-button class="w-10 h-10 p-2 rounded-full" :class="minusClass" :disabled="value <= props.min" @click="handleMinusClick">
          <svg-icon name="minus" class="w-6 h-6" />
        </nd-button>
        <span :class="valueClass">{{ value }}</span>
        <nd-button class="w-10 h-10 p-2 rounded-full" :class="plusClass" :disabled="value >= props.max" @click="handlePlusClick">
          <svg-icon name="plus" class="w-6 h-6" />
        </nd-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    min?: number
    max?: number
    step?: number
    size?: 'small' | 'default' | 'large'
    value?: number
  }>(),
  {
    min: 1,
    max: 99,
    step: 1,
    size: 'default',
  }
)
const emit = defineEmits<{
  (event: 'update:value', val: number): void
}>()

const value = ref(props.value || props.min)

const minusClass = computed(() => [value.value <= props.min ? 'text-gray-40' : 'text-yellow-50'])
const plusClass = computed(() => [value.value >= props.max ? 'text-gray-40' : 'text-yellow-50'])

const valueClass = computed(() => {
  const sizeClassMap = {
    small: 'text-sm',
    default: 'text-base',
    large: 'text-lg',
  }
  return [sizeClassMap[props.size], 'text-black-50']
})

const handleMinusClick = () => {
  if (value.value > props.min) {
    value.value -= props.step
  }
}

const handlePlusClick = () => {
  if (value.value < props.max) {
    value.value += props.step
  }
}

watch(
  () => props.value,
  val => {
    value.value = val ?? props.min
  }
)

watch(value, val => emit('update:value', val))
</script>

<style lang="scss" scoped></style>
